module.exports = __webpack_public_path__ + "static/media/location_map_dark.bd412fc2.svg";